const state = {
  payload: null,
  server: null,
  error: null,
  receivedAt: null
}

const getters = {
  pvpUsageStats: state => state.payload,
  pvpUsageStatsServer: state => state.server,
  pvpUsageStatsError: state => state.error,
  pvpUsageStatsReceivedAt: state => state.receivedAt
}

const actions = {
  getPvpUsageStats ({ commit }, payload) {
    commit('setPvpUsageStats', payload)
  },
  setError ({ commit }, payload) {
    commit('setError', payload.data)
  }
}

const mutations = {
  setPvpUsageStats (state, payload) {
    state.payload = payload.data && payload.data.data ? payload.data.data : null
    state.server = payload.data ? payload.data.server : null
    state.error = null
    state.receivedAt = Date.now()
  },
  setError (state, error) {
    state.error = { error, time: Date.now() }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
